import {
  ACTION_EDIT_CAMPAIGN__REQUEST,
  ACTION_EDIT_CAMPAIGN__SUCCESS,
  ACTION_EDIT_CAMPAIGN__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_CAMPAIGN__REQUEST:
    case ACTION_EDIT_CAMPAIGN__SUCCESS:
      return null;

    case ACTION_EDIT_CAMPAIGN__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
